fragment EditHistoryFields on EditHistory {
  date
  field
  changedFrom
  changedTo
  changedBy {
    fullName
    id
    avatarUrl
  }
  comment
}
